import React from "react";
import { useHistory } from "react-router-dom";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

export default function Enemy({ data }) {
  const history = useHistory(); //habilitar history para redirecciones
  const onClick = (id) => {
    history.push(`enemy-detail/${id}`);
  };
  return (
    <Card
      sx={{ maxWidth: 345 }}
      style={{ cursor: "pointer" }}
      onClick={() => onClick(data._id)}
    >
      <CardMedia
        component="img"
        height="190"
        //weight="200"
        image={data.image}
        alt="charIcon"
      />
      <CardContent>
        <Typography variant="subtitle1" align="center">
          {data.name}
        </Typography>
      </CardContent>
    </Card>
  );
}
